import Api from '@/api/index';
import indexedDB from '@/db/index'

const Category = {
  namespaced: true,

  state: {
    one_category: null,
    all_categories: []
  },

  getters: {
    getOneCategory: (state) => {
      return state.one_category;
    },
    getAllCategories: (state) => {
      return state.all_categories;
    }
  },

  mutations: {
    setOneCategory(state, category) {
      state.one_category = {...category};
    },
    setAllCategories(state, categories) {
      state.all_categories = [...categories];
    },
    pushToAllCategories(state, category) {
      state.all_categories.push({...category});
    },
    updateCategory(state, category) {
      let idx = state.all_categories.findIndex(c => c.id == category.id);
      state.all_categories.splice(idx, 1, {...category});
    },
    deleteCategory(state, category) {
      let idx = state.all_categories.findIndex(c => c.id == category.id);
      state.all_categories.splice(idx, 1)
    },
  },

  actions: {
    async getLocalCategories({commit}) {
      let categories = await indexedDB.Category.getAllCategories();
      commit('setAllCategories', categories);
    },
    async setLocalCategories({}, categories) {
      await indexedDB.Category.createBulkCategories(categories);
    },
    setOneCategory({commit}, category) {
      commit('setOneCategory', category);
    },
    setAllCategories({commit}, categories) {
      commit('setAllCategories', categories);
    },
    index({commit, dispatch}) {
      Api.Category.index().then(r=> r.data).then(categories => {
        commit('setAllCategories', categories);
        dispatch('setLocalCategories', categories);
      }).catch(error => {
        console.log(error);
      })
    },
    create({commit, dispatch}, category) {
      let notification = {};
      Api.Category.create(category).then(r => r.data).then(category => {
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        commit('pushToAllCategories', category);
        return true;
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch('Notification/add', notification, {root: true})
      })
    },
    update({commit, dispatch}, category) {
      let notification = {};
      Api.Category.update(category).then(r => r.data).then(category => {
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        commit('updateCategory', category);
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch('Notification/add', notification, {root: true});
      })
    },
    delete({commit, dispatch}, category) {
      let notification = {};
      Api.Category.delete(category.id).then(r => r.data).then(r => {
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        commit('deleteCategory', category);
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`
      }).finally(() => {
        dispatch('Notification/add', notification, {root: true});
      })
    }
  }
}

export default Category;